// Database of OSP Tasks for Mission Generation
import { OSPWeakness } from '../types/onboarding';

export interface OspTaskInfo {
    id: string;
    title: string;
    category: 'Analytický oddíl' | 'Verbální oddíl';
    prompt: string;
    isFree: boolean; // For future use if we want to lock some types
}

export const OSP_TASK_DATABASE: OspTaskInfo[] = [
    // --- Analytický oddíl ---
    {
        id: 'grafy-a-tabulky',
        title: 'Grafy a tabulky',
        category: 'Analytický oddíl',
        prompt: 'Ahoj, chci procvičit Grafy a tabulky (interpretace dat). Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'porovnavani-hodnot',
        title: 'Porovnávání hodnot',
        category: 'Analytický oddíl',
        prompt: 'Ahoj, chci procvičit Porovnávání hodnot (algebraické vztahy). Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'dostacujici-tvrzeni',
        title: 'Dostačující tvrzení',
        category: 'Analytický oddíl',
        prompt: 'Ahoj, chci procvičit Dostačující tvrzení (Data Sufficiency). Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'slovni-ulohy',
        title: 'Slovní úlohy',
        category: 'Analytický oddíl',
        prompt: 'Ahoj, chci procvičit Slovní úlohy (převod textu na rovnice). Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'matematizace',
        title: 'Matematizace',
        category: 'Analytický oddíl',
        prompt: 'Ahoj, chci procvičit Matematizaci (práce s abstraktními výrazy). Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'vynechavky',
        title: 'Vynechávky (Substituce)',
        category: 'Analytický oddíl',
        prompt: 'Ahoj, chci procvičit Vynechávky a substituce v algebraických výrazech. Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'smyslene-operace',
        title: 'Smyšlené operace',
        category: 'Analytický oddíl',
        prompt: 'Ahoj, chci procvičit Smyšlené operace. Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'funkce',
        title: 'Funkce',
        category: 'Analytický oddíl',
        prompt: 'Ahoj, chci procvičit Funkce a funkční závislosti. Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'zebry',
        title: 'Zebry (Logické úlohy)',
        category: 'Analytický oddíl',
        prompt: 'Ahoj, chci procvičit Zebry (logické úlohy a dedukce). Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },

    // --- Verbální oddíl ---
    {
        id: 'doplnovani-do-vet',
        title: 'Doplňování do vět',
        category: 'Verbální oddíl',
        prompt: 'Ahoj, chci procvičit Doplňování slov do vět. Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'vztahy-mezi-slovy',
        title: 'Vztahy mezi slovy (Analogie)',
        category: 'Verbální oddíl',
        prompt: 'Ahoj, chci procvičit Vztahy mezi slovy (Analogie). Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'synonyma-antonyma',
        title: 'Synonyma a antonyma',
        category: 'Verbální oddíl',
        prompt: 'Ahoj, chci procvičit Synonyma a antonyma v kontextu. Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'kratke-texty',
        title: 'Krátké texty',
        category: 'Verbální oddíl',
        prompt: 'Ahoj, chci procvičit porozumění Krátkým textům. Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'dlouhe-texty',
        title: 'Dlouhé texty',
        category: 'Verbální oddíl',
        prompt: 'Ahoj, chci procvičit porozumění Dlouhým textům (Fact-Free Zone). Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'porovnavani-textu',
        title: 'Porovnávání textů',
        category: 'Verbální oddíl',
        prompt: 'Ahoj, chci procvičit Porovnávání textů. Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    },
    {
        id: 'co-neni-v-souladu',
        title: 'Co není v souladu',
        category: 'Verbální oddíl',
        prompt: 'Ahoj, chci procvičit úlohy typu "Co není v souladu" s textem. Nejdřív mi stručně vysvětli princip a na co si dát pozor, a pak mi dej příklad k procvičení.',
        isFree: true
    }
];



// ... (existing helper functions)

// Map weaknesses to specific task IDs for the first 3 days
const WEAKNESS_TASK_MAP: Record<string, string[]> = {
    'logic': ['zebry', 'dostacujici-tvrzeni', 'slovni-ulohy'],
    'data': ['grafy-a-tabulky', 'porovnavani-hodnot', 'matematizace'],
    'reading': ['doplnovani-do-vet', 'vztahy-mezi-slovy', 'kratke-texty']
};

/**
 * Get the next task in rotation logic
 * Includes prioritization for weaknesses in the first 3 days
 */
export function getNextOspTask(dayIndex: number, weakness?: OSPWeakness): OspTaskInfo {
    // 1. Weakness Prioritization (Days 1-3)
    if (dayIndex <= 3 && weakness && weakness !== 'unsure' && WEAKNESS_TASK_MAP[weakness]) {
        const priorityTasks = WEAKNESS_TASK_MAP[weakness];
        // Cycle through the 3 priority tasks
        const priorityIndex = (dayIndex - 1) % priorityTasks.length;
        const taskId = priorityTasks[priorityIndex];
        const task = OSP_TASK_DATABASE.find(t => t.id === taskId);
        if (task) return task;
    }

    // 2. Standard Rotation (Day 4+ or no weakness)
    // Simple rotation: Task index = dayIndex % totalTasks
    // We intentionally offset the rotation by the dayIndex to ensure variety continues
    // even if they switch out of the priority period
    const index = (dayIndex - 1) % OSP_TASK_DATABASE.length;
    return OSP_TASK_DATABASE[index];
}

/**
 * Get task details by ID
 */
export function getOspTaskById(id: string): OspTaskInfo | undefined {
    return OSP_TASK_DATABASE.find(task => task.id === id);
}
